export interface AssistantConversationScopeInput {
  enabled: boolean;
  userClerkId: string;
  userId: string;
  orgClerkId: string;
  orgId: string;
  isSuperAdmin: boolean;
  hasAllPermissions: boolean;
  role: string;
  permissions: readonly string[];
}

/** Returns null until every signed identity and entitlement dimension is trustworthy. */
export const assistantConversationScopeKey = (input: AssistantConversationScopeInput): string | null => {
  if (!input.enabled || !input.userClerkId || !input.userId || !input.orgClerkId || !input.orgId) {
    return null;
  }
  return JSON.stringify({
    userClerkId: input.userClerkId,
    userId: input.userId,
    orgClerkId: input.orgClerkId,
    orgId: input.orgId,
    entitlement: "ai-enabled",
    authorization: {
      isSuperAdmin: input.isSuperAdmin,
      hasAllPermissions: input.hasAllPermissions,
      role: input.role,
      permissions: [...input.permissions].sort(),
    },
  });
};
